import { API_ENDPOINTS } from "../config/api";
import { apiRequest } from "./httpClient";

export const getAllJobCategories = async (
  {
    page,
    size,
    search,
    location,
    category,
    yearsOfExperience,
    jobType,
    timePeriod,
  },
  token
) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);

  if (search) params.append("searchQuery", search);
  if (location) params.append("location", location);
  if (category) params.append("jobCategoryId", category);
  if (jobType) params.append("jobType", jobType);
  if (yearsOfExperience) params.append("yearsOfExperience", yearsOfExperience);
  if (timePeriod) params.append("timePeriod", timePeriod);

  if (!API_ENDPOINTS?.JOB_CATEGORIES) {
    throw new Error("Endpoint de categorias não configurado");
  }

  return apiRequest(
    `${API_ENDPOINTS.JOB_CATEGORIES}?${params.toString()}&sort=createdAt,desc`,
    {
      method: "GET",
      token,
      fallbackMessage: "Erro ao buscar categorias",
      errorCode: "JOB_CATEGORIES_FAILED",
    }
  );
};
